const getBase64 = async (file) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  await new Promise((resolve) => (reader.onload = resolve));

  return reader.result;
}

export default getBase64;